/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} First_CaptionInputs */



/**
* | output |
* | --- |
* | "First Caption:" |
*
* @param {First_CaptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const first_caption = /** @type {((inputs?: First_CaptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<First_CaptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Première légende :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erste Bildunterschrift:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prima didascalia:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Первая подпись:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Primer subtítulo:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("第一条标题：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最初のキャプション:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहला कैप्शन:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Primeira legenda:")
	return /** @type {LocalizedString} */ ("First Caption:")
});